const SERVICES = [
  {
    title: "Landscaping & Yard Work",
    description: "Mowing, trimming, planting, cleanup. Real outdoor labor — fast hire.",
    icon: "ri-plant-line",
    color: "from-green-500 to-emerald-600",
    lightColor: "bg-green-50",
    textColor: "text-green-700",
    image: "https://public.readdy.ai/ai/img_res/ba90f9a37c9003765243c710d259ce11.jpg",
    workers: "1,200+",
  },
  {
    title: "Moving & Heavy Labor",
    description: "Loading, unloading, furniture moving. Strong workers available today.",
    icon: "ri-truck-line",
    color: "from-orange-500 to-amber-500",
    lightColor: "bg-orange-50",
    textColor: "text-orange-700",
    image: "https://readdy.ai/api/search-image?query=two%20strong%20movers%20workers%20carrying%20furniture%20boxes%20into%20truck%20bright%20daytime%20residential%20street%20clean%20simple%20background%20warm%20tones%20professional%20laborers&width=400&height=300&seq=svc2&orientation=landscape",
    workers: "850+",
  },
  {
    title: "Cleaning Services",
    description: "Residential, commercial, post-construction. Verified cleaners ready.",
    icon: "ri-brush-2-line",
    color: "from-sky-500 to-cyan-500",
    lightColor: "bg-sky-50",
    textColor: "text-sky-700",
    image: "https://readdy.ai/api/search-image?query=female%20professional%20cleaner%20cleaning%20bright%20modern%20kitchen%20white%20surfaces%20sparkling%20clean%20mop%20bucket%20uniform%20cheerful%20light%20simple%20background%20blue%20tones&width=400&height=300&seq=svc3&orientation=landscape",
    workers: "2,100+",
  },
  {
    title: "Construction & Building",
    description: "Framing, demolition, general labor. Site-ready workers, hired fast.",
    icon: "ri-hammer-line",
    color: "from-yellow-500 to-amber-600",
    lightColor: "bg-yellow-50",
    textColor: "text-yellow-700",
    image: "https://readdy.ai/api/search-image?query=construction%20worker%20hard%20hat%20safety%20vest%20on%20building%20site%20framing%20wood%20beams%20daylight%20blue%20sky%20warm%20tones%20professional%20tools%20confident%20worker&width=400&height=300&seq=svc4&orientation=landscape",
    workers: "960+",
  },
  {
    title: "Events & Staffing",
    description: "Setup, breakdown, crowd management. Flexible event workers.",
    icon: "ri-calendar-event-line",
    color: "from-violet-500 to-purple-600",
    lightColor: "bg-violet-50",
    textColor: "text-violet-700",
    image: "https://readdy.ai/api/search-image?query=event%20staff%20workers%20setting%20up%20chairs%20tables%20at%20elegant%20venue%20banquet%20hall%20bright%20lights%20clean%20organized%20professional%20crew%20uniform&width=400&height=300&seq=svc5&orientation=landscape",
    workers: "640+",
  },
  {
    title: "Driving & Delivery",
    description: "Local delivery, courier, chauffeur. Get reliable drivers instantly.",
    icon: "ri-car-line",
    color: "from-slate-600 to-gray-700",
    lightColor: "bg-slate-50",
    textColor: "text-slate-700",
    image: "https://readdy.ai/api/search-image?query=smiling%20delivery%20driver%20holding%20packages%20at%20door%20clean%20white%20van%20residential%20neighborhood%20daytime%20neat%20uniform%20professional%20courier&width=400&height=300&seq=svc6&orientation=landscape",
    workers: "730+",
  },
];

export default function ServicesShowcase() {
  return (
    <section className="py-16 md:py-24 bg-[#f7f9f8]">
      <div className="max-w-7xl mx-auto px-4 md:px-8">

        {/* Section Header */}
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block text-xs font-bold uppercase tracking-widest text-emerald-600 bg-emerald-50 px-4 py-1.5 rounded-full mb-4">
            What We Do
          </span>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-extrabold text-gray-900 mb-4 leading-tight">
            Real Work.<br className="sm:hidden" />
            <span className="text-emerald-500"> Real People.</span>
          </h2>
          <p className="text-gray-500 text-base md:text-lg max-w-xl mx-auto">
            From physical gigs to skilled trades — Gig <span className="italic">n&apos;</span> Cash connects employers with qualified workers across every category.
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {SERVICES.map((service) => (
            <div
              key={service.title}
              className="group rounded-2xl overflow-hidden bg-white border border-gray-100 hover:border-emerald-200 transition-all duration-300 cursor-pointer"
            >
              {/* Image */}
              <div className="relative w-full h-48 overflow-hidden">
                <img
                  src={service.image}
                  alt={service.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                {/* Gradient overlay */}
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent" />
                {/* Worker count badge */}
                <div className="absolute bottom-3 left-3 flex items-center gap-1.5 bg-white/90 backdrop-blur-sm rounded-full px-2.5 py-1">
                  <div className="w-1.5 h-1.5 bg-emerald-500 rounded-full animate-pulse" />
                  <span className="text-xs font-bold text-gray-900">{service.workers} workers</span>
                </div>
                {/* Icon badge */}
                <div className={`absolute top-3 right-3 w-9 h-9 flex items-center justify-center bg-gradient-to-br ${service.color} rounded-xl`}>
                  <i className={`${service.icon} text-white text-base`} />
                </div>
              </div>

              {/* Content */}
              <div className="p-4 md:p-5">
                <h3 className="font-bold text-gray-900 text-base mb-1.5">{service.title}</h3>
                <p className="text-sm text-gray-500 leading-relaxed mb-4">{service.description}</p>
                <div className="flex items-center justify-between">
                  <span className={`text-xs font-semibold px-2.5 py-1 rounded-full ${service.lightColor} ${service.textColor}`}>
                    Hire Now
                  </span>
                  <div className="flex items-center gap-1 text-xs text-gray-400 font-medium">
                    <i className="ri-flashlight-line text-emerald-500" />
                    Same-day available
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* CTA Banner — no logo, strong text only */}
        <div className="mt-10 bg-gradient-to-r from-emerald-500 to-emerald-600 rounded-2xl p-6 md:p-8 flex flex-col sm:flex-row items-center justify-between gap-5">
          <div>
            <div className="text-white font-extrabold text-xl md:text-2xl mb-1">Every skill earns here.</div>
            <p className="text-emerald-50 text-sm max-w-xs">
              Match with a job in under 4 minutes — no degree, no resume required.
            </p>
          </div>
          <div className="flex flex-col sm:flex-row gap-3 w-full sm:w-auto">
            <a
              href="/find-work"
              className="px-6 py-3 bg-white text-emerald-700 font-bold rounded-xl text-sm hover:bg-emerald-50 transition-colors cursor-pointer whitespace-nowrap text-center inline-flex items-center justify-center gap-2"
            >
              <i className="ri-search-line" />
              Find Work Today
            </a>
            <a
              href="/hire"
              className="px-6 py-3 bg-white/10 border border-white/20 text-white font-bold rounded-xl text-sm hover:bg-white/20 transition-colors cursor-pointer whitespace-nowrap text-center inline-flex items-center justify-center gap-2"
            >
              <i className="ri-briefcase-line" />
              Post a Job
            </a>
          </div>
        </div>

      </div>
    </section>
  );
}
